// extracted by mini-css-extract-plugin
export default {"container":"eQ-z","topReviewHeading":"fQ-z","criticalReview":"gQ-z","favorableReview":"hQ-z","vsSeparator":"iQ-z"};